import React from 'react';
import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootswatch/dist/sketchy/bootstrap.min.css'
import Home from './components/Home/Home';
function App() {
  return (
    <div>
      <Home />
    </div>
  )
}

export default App;
